import { GalleryPublication } from 'common/client-data-types/publication'
import { getCommonProps } from 'common/__api-mapping/v4/publication/map/common'
import { mergeImageDtosToImageSource, imageWithCropsDtoToImageCrop } from '../../lib/to-image'
import { GalleryV4DTO } from 'publication-types'

export function mapGallery(publication: GalleryV4DTO): GalleryPublication {
    const commonProps = getCommonProps(publication)
    const images = publication.photoGallery.images.map(imageWithCropsDtoToImageCrop)
    const heroImage = mergeImageDtosToImageSource(...publication.mainImages)

    return {
        ...commonProps,
        kind: 'gallery',
        heroImage,
        socialTeaser: publication.socialTeaser || undefined,
        socialHead: publication.socialHead || undefined,
        homepageHead: publication.homepageHead,
        teaser: publication.homepageTeaser,
        heading: publication.heading,
        images,
        shareUrl: publication._self,
        isPremium: publication.isPremium || false,
    }
}
